import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { AudienceProvider, AudienceSwitch } from "@/components/network/NetworkAtoms";
import NetworkHero from "@/components/network/NetworkHero";
import ThirtySecond from "@/components/network/ThirtySecond";
import MembersReveal from "@/components/network/MembersReveal";
import JourneyScroll from "@/components/network/JourneyScroll";
import CapabilityGrid from "@/components/network/CapabilityGrid";
import MarketContext from "@/components/network/MarketContext";
import PartnerCriteria from "@/components/network/PartnerCriteria";
import NetworkClose from "@/components/network/NetworkClose";
import { ExplainerProvider } from "@/components/network/ExplainerVideo";

// Title, description and share card for this page live in src/seo/pages.js, applied by RouteSeo.

export default function LendingNetwork() {
  const [audience, setAudience] = useState("introducer");

  return (
    <AudienceProvider value={{ audience, setAudience }}>
      <ExplainerProvider>
        <main className="relative bg-[#0B1220] text-slate-300 overflow-hidden" data-testid="lending-network">
          <NetworkHero />
          <ThirtySecond />
          <MembersReveal />
          <JourneyScroll />
          <CapabilityGrid />
          <MarketContext />
          <PartnerCriteria />
          <NetworkClose />
          <FloatingSwitch />
        </main>
      </ExplainerProvider>
    </AudienceProvider>
  );
}

/** Appears once the hero is behind you, out of the way bottom-right. */
function FloatingSwitch() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setShow(y > 620 && y + window.innerHeight < document.body.scrollHeight - 420);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed z-40 bottom-4 inset-x-0 flex justify-center sm:inset-x-auto sm:right-6 sm:bottom-6 sm:justify-end pointer-events-none">
      <AnimatePresence>
        {show && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.96 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
            className="pointer-events-auto"
            data-testid="audience-toggle-floating"
          >
            <AudienceSwitch floating />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
